<div class="similar-datasets" *ngIf="hasItems">
  <h6 class="similar-datasets--heading">{{ title }}</h6>
  <div class="similar-datasets--carousel-wrapper">
    <app-carousel
      [items]="carouselItems"
      [itemsToShow]="itemsToShow"
      [showDots]="showDots"
      [showArrows]="showArrows"
      [gap]="gap"
    >
      @if (assetType === 'model') {
        @for (model of models; track model.id) {
          <div class="carousel-item">
            <app-model-card
              [card]="model"
              [likeActionEnabled]="false"
              class="similar-datasets--model-card"
            ></app-model-card>
          </div>
        }
      } @else if (assetType === 'dataset') {
        @for (card of featureCards; track card.id) {
          <div class="carousel-item">
            <app-feature-card
              [card]="card"
              [likeActionEnabled]="false"
              class="similar-datasets--feature-card"
            ></app-feature-card>
          </div>
        }
      } @else {
        @for (dataset of datasets; track dataset.id) {
          <div class="carousel-item">
            <app-asset-card [data]="dataset" [assetType]="assetType"></app-asset-card>
          </div>
        }
      }
    </app-carousel>
  </div>
</div>
